import { ECategory } from '../../../../common/repositories/price-estimator/entities/web/CreateSuburbanRealtyRequestSchema';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';

export const mapEstimationTargetToECategory: { [key: string]: ECategory } = {
  [EMyHomeEstimationTargets.house]: ECategory.HouseSale,
  [EMyHomeEstimationTargets.land]: ECategory.LandSale,
};
